import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import TabletAndMobileContainer from '~/components/shared/deviceContainers/TabletAndMobileContainer';
import DesktopContainer from '~/components/shared/deviceContainers/DesktopContainer';

const AnimationPlayer = ({
  animationUrl,
  backgroundColor,
  animationSpeed,
  width,
  deviceWidth,
  height,
  deviceHeight,
  loop,
  autoplay,
  hover,
  playMode
}) => (
  <>
    <DesktopContainer>
      <Player
        src={animationUrl}
        background={backgroundColor}
        speed={animationSpeed}
        style={{
          width,
          height
        }}
        loop={loop}
        autoplay={autoplay}
        hover={hover}
        mode={playMode}
      />
    </DesktopContainer>
    <TabletAndMobileContainer>
      <Player
        src={animationUrl}
        background={backgroundColor}
        speed={animationSpeed}
        style={{
          width: deviceWidth,
          height: deviceHeight
        }}
        loop={loop}
        autoplay={autoplay}
        hover={hover}
        mode={playMode}
      />
    </TabletAndMobileContainer>
  </>
);

export default AnimationPlayer;
